export default __webpack_public_path__ + "static/media/zertiassist_iconos_home_24px.91bc8a92.svg";